import * as Yup from 'yup';

import { isValidOptionalUrl, requiredString } from './common';

/** Mirrors `POST /admin/launchpad/enums` — keep in sync with categoryConstants. */
const COMPLETION_VALUES = ['AUTO', 'WATCH_VIDEO', 'MANUAL_ACK'];
const REDIRECTION_VALUES = [
  'PENDING_SETUP_BUSINESS',
  'PENDING_UPDATE_BUSINESS_PROFILE',
  'PENDING_BASIC_DETAILS',
  'PENDING_LOCATION',
  'PENDING_MENU',
  'PENDING_GALLERY',
  'PENDING_LINKS_FOR_CUSTOMERS',
  'PENDING_BUSINESS_HOURS',
  'DOWNLOAD_QR',
  'CONNECT_CRM',
  'ADD_TEAM',
  'CREATE_FIRST_POST',
  'CREATE_YOUR_FIRST_NUDGE',
  'GET_MORE_FOLLOWER',
  'DOWNLOAD_PRINTABLE',
];
const MEDIA_VALUES = ['IMAGE', 'VIDEO', 'PDF'];

export const categoryFormSchema = Yup.object({
  title: requiredString('Title').trim().max(100, 'Title must be at most 100 characters'),
  description: requiredString('Description')
    .trim()
    .max(500, 'Description must be at most 500 characters'),
  icon: requiredString('Icon').trim(),
  sortOrder: Yup.number()
    .typeError('Sort order must be a number')
    .integer('Sort order must be a whole number')
    .min(0, 'Sort order must be 0 or greater')
    .required('Sort order is required'),
  active: Yup.boolean().required(),
});

export const categorySectionFormSchema = Yup.object({
  title: requiredString('Title').trim().max(100, 'Title must be at most 100 characters'),
  description: requiredString('Description')
    .trim()
    .max(500, 'Description must be at most 500 characters'),
  icon: requiredString('Icon').trim(),
  estimatedTime: requiredString('Estimated time').trim().max(50, 'Estimated time is too long'),
  videoUrl: Yup.string()
    .trim()
    .test('optional-url', 'Enter a valid video URL', (value) => {
      const trimmed = typeof value === 'string' ? value.trim() : '';
      if (!trimmed) return true;
      if (trimmed.startsWith('blob:')) return true;
      return isValidOptionalUrl(trimmed);
    }),
  percentage: Yup.number()
    .typeError('Percentage must be a number')
    .min(0, 'Percentage must be between 0 and 100')
    .max(100, 'Percentage must be between 0 and 100')
    .required('Percentage is required'),
  completionType: Yup.string()
    .required('Completion type is required')
    .oneOf(COMPLETION_VALUES, 'Select a valid completion type'),
  redirection: Yup.string()
    .required('Redirection is required')
    .oneOf(REDIRECTION_VALUES, 'Select a valid redirection'),
  qrCode: Yup.string()
    .trim()
    .max(2048, 'QR code file URL is too long')
    .test('optional-url', 'Enter a valid QR file URL', (value) => {
      const trimmed = typeof value === 'string' ? value.trim() : '';
      if (!trimmed) return true;
      if (trimmed.startsWith('blob:')) return true;
      return isValidOptionalUrl(trimmed);
    }),
  sortOrder: Yup.number()
    .typeError('Sort order must be a number')
    .integer('Sort order must be a whole number')
    .min(0, 'Sort order must be 0 or greater')
    .required('Sort order is required'),
  active: Yup.boolean().required(),
  media: Yup.array()
    .of(
      Yup.object({
        mediaType: Yup.string().oneOf(MEDIA_VALUES).required(),
        mediaUrl: requiredString('Media URL').trim(),
        sortOrder: Yup.number().min(0).required(),
      }),
    )
    .default([]),
});

export const categorySubsectionFormSchema = Yup.object({
  title: requiredString('Title').trim().max(100, 'Title must be at most 100 characters'),
  description: requiredString('Description')
    .trim()
    .max(500, 'Description must be at most 500 characters'),
  estimatedTime: requiredString('Estimated time').trim().max(50, 'Estimated time is too long'),
  redirection: Yup.string()
    .required('Redirection is required')
    .oneOf(REDIRECTION_VALUES, 'Select a valid redirection'),
  sortOrder: Yup.number()
    .typeError('Sort order must be a number')
    .integer('Sort order must be a whole number')
    .min(0, 'Sort order must be 0 or greater')
    .required('Sort order is required'),
  active: Yup.boolean().required(),
});
